export const playStoreLink =
  "https://play.google.com/store/apps/details?id=com.sprinterwave&pcampaignid=web_share";
export const appStoreLink = "https://apps.apple.com/app/sprinterwave/id6446461680";

export type Platform = "ios" | "android" | "other";

export function getPlatform(): Platform {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return "other";
  }

  const userAgent = navigator.userAgent;

  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
  if (isIOS) return "ios";

  if (/Android/.test(userAgent)) return "android";

  return "other";
}

export function getDownloadLink(platform: Platform = getPlatform()): string {
  return platform === "ios" ? appStoreLink : playStoreLink;
}